import React, { useEffect, useRef, useState } from 'react'
import { Header } from './header'
import Slider from "react-slick";
import { NextArrow, PrevArrow } from './CustomArrows';
import { Footer } from './footer';
import { useNavigate } from 'react-router-dom';
import { listcategory, listcategorycount, listhomeslider, listproduct } from '../services/homeser';
import { HomeSEO } from './SEO';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from "swiper/modules";
import 'swiper/css';
export const Home = () => {
    const navigate = useNavigate();
    const [hslider, setHslider] = useState([]);
    const [cntlist, setCntlist] = useState([]);
    const [wlist, setWlist] = useState([]);
    const [plist, setPlist] = useState([]);

    // Drive the category slider's visible count from the viewport width so the
    // 2-up mobile grid is deterministic (react-slick's own responsive matching
    // was falling back to the desktop settings).
    const getSlides = (w) => (w <= 768 ? 2 : w <= 992 ? 3 : w <= 1200 ? 4 : 5);
    const [catSlides, setCatSlides] = useState(
        getSlides(typeof window !== 'undefined' ? window.innerWidth : 1200)
    );
    useEffect(() => {
        const onResize = () => setCatSlides(getSlides(window.innerWidth));
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    useEffect(() => {
        const temp1 = new FormData();
        temp1.append('active', 1);
        listhomeslider(temp1).then((res) => {
            if (res.status) {
                setHslider(res.data);
            }
        })
        // Fetch the active category list first (listcategory is already filtered
        // to active == 1 at the service level), then keep only the count rows
        // whose category is active. category_counts itself has no active flag.
        listcategory().then((catRes) => {
            const activeIds = new Set((catRes?.data || []).map((c) => c.id));
            listcategorycount().then((res) => {
                if (res.status) {
                    const counts = (res.data.category_counts || []).filter((c) =>
                        activeIds.has(c?.product_category?.id)
                    );
                    setCntlist(counts);
                }
            });
        })

        const temp = new FormData();
        listproduct(temp).then((res) => {
            if (res.status) {
                setPlist(res.data);
                const sdata = res.data
                    .filter((x) => x.product_category_id == 1)
                    .slice(0, 8);

                setWlist(sdata);
            }
        })

        // fetch("http://localhost:8000/api/reviews")
        // .then(res => res.json())
        // .then(data => setReviews(data))
        // .catch(err => console.log(err));
    }, [])
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };


    const isMobile = catSlides <= 2;
    const smallsettings = {
        dots: isMobile,
        infinite: cntlist.length > catSlides,
        speed: 500,
        slidesToShow: catSlides,
        slidesToScroll: 1,
        // Center peeks only on desktop; mobile is a clean 2-up grid
        centerMode: !isMobile,
        centerPadding: isMobile ? "0px" : "40px",
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        arrows: !isMobile,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    // const premiumsettings = {
    //     dots: false,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 5,
    //     slidesToScroll: 1,
    //     nextArrow: <NextArrow />,
    //     prevArrow: <PrevArrow />,
    //     autoplay: true,
    //     autoplaySpeed: 3000,
    //     responsive: [
    //         { breakpoint: 1200, settings: { slidesToShow: 4 } },
    //         { breakpoint: 992, settings: { slidesToShow: 3 } },
    //         { breakpoint: 768, settings: { slidesToShow: 2 } },
    //         { breakpoint: 480, settings: {slidesToShow: 1,arrows: false,centerMode: true}
    //         }
    //     ]
    // };
    const premiumsettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5, // Default for Desktop
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1025,
                settings: { slidesToShow: 4 }
            },
            {
                breakpoint: 769,
                settings: { slidesToShow: 2 }
            },
            {
                // This covers everything from 480px down to 321px
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    centerPadding: '0px'
                }
            },

        ]
    };


    const testimonialSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1, // Only show 1 full card at a time
        centerMode: true, // This enables the side-preview effect
        centerPadding: "250px", // Adjust this value to show more/less of side cards
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        autoplay: true,
        autoplaySpeed: 4000,
        rtl: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: { centerPadding: "150px" }
            },
            {
                breakpoint: 992,
                settings: {
                    centerPadding: "100px",
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: "50px",
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false, // CRITICAL: Turn this off
                    centerPadding: "0px",
                    arrows: false,
                    dots: false,
                    variableWidth: false, // Ensure this is false
                    adaptiveHeight: true
                }
            }
        ]
    };

    const responsiveTestimonialSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,

        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    centerPadding: "150px"
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerPadding: "100px"
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: "50px"
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,   // ✅ now fully controlled
                    centerPadding: "0px",
                    arrows: false,
                    dots: false,
                    variableWidth: false,
                    adaptiveHeight: true
                }
            }
        ]
    };

    const reviews = [
        {
            text: "We got our marriage invitations printed here, and the quality was excellent. They have a huge collection of designs and very good pricing. Highly recommended for wedding cards in Salem.",
            name: "Ramesh Kumar – Salem",
            img: require("../assets/images/slider/testimonial.jpg") // Replace with your actual path
        },
        {
            text: "ASM Wedding Cards provided us with beautiful custom wedding invitations at an affordable price. The printing quality and finishing were top-class.",
            name: "Priya & Arun – Attur",
            img: require("../assets/images/slider/testimonial.jpg")
        },
        {
            text: "The team was very supportive and helped us choose the perfect design. Delivery was quick,and everything was done on time.",
            name: "Karthik Raj – Rasipuram",
            img: require("../assets/images/slider/testimonial.jpg") // Replace with your actual path
        },
        {
            text: "They have more than 2000+ designs. Whether you want traditional or modern wedding cards,this is the best place in Salem",
            name: "Ranjithkumar pooja - Vazhapadi",
            img: require("../assets/images/slider/testimonial.jpg")
        },
    ];

    return (
        <>
            <HomeSEO />
            <Header />




            {/*  
           */}



            <section className="home-banner-section">
                <div className="container-fluid p-0">
                    <Slider {...settings} className="main-slider">
                        {hslider.map((item, index) => (
                            <div key={index} className="slider-item">
                                <img src={item.slider_images[0]} alt="Slide 1" className="w-100" />
                            </div>
                        ))}
                        {/* <div className="slider-item">
                            <img src={require("../assets/images/slider/02.jpg")} alt="Slide 1" className="w-100" />
                        </div>
                        <div className="slider-item">
                            <img src={require("../assets/images/slider/03-1.jpg")} alt="Slide 2" className="w-100" />
                        </div> */}
                    </Slider>
                </div>
            </section>




            <section className="section suggest-part">
                <div className="container">

                    {cntlist.length > 0 && (
                        <Slider key={catSlides} {...smallsettings} className="suggest-slider">
                            {cntlist.map((item, index) => (
                                <div key={index} className="slider-item-padding">
                                    {/* onClick={() => navigate('/cards')} */}
                                    <a className="suggest-card" onClick={() =>
                                        navigate(
                                            `/${item?.product_category.category_name
                                                .toLowerCase()
                                                .replace(/\s+/g, "-")}`
                                        )
                                    }>
                                        <img src={item?.product_category.category_image} alt={item?.product_category.category_name} />
                                        <div className="card-overlay">
                                            <h5>
                                                {item?.product_category.category_name} <span>{item.total} Items</span>
                                            </h5>
                                        </div>
                                    </a>
                                </div>
                            ))}

                        </Slider>
                    )}
                </div>
            </section>

            <section className="section recent-part">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-heading">
                                <h2>Trendy Wedding Invitations</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
                        {wlist.map((item, index) => (
                            <div className="col" key={index}>
                                <div className="product-card">
                                    <div className="product-media">
                                        {/* <div className="product-label">
                                            <label className="label-text new">new</label>
                                        </div> */}
                                        {/* <button className="product-wish wish">
                                            <i className="fas fa-heart"></i>
                                        </button> */}
                                        <button
                                            className="product-wish wish active"
                                            onClick={() => {
                                                const phone = "919865230900"; // include country code (91 for India)
                                                const message = encodeURIComponent(
                                                    `Hi, I’d like to know more about this product: ${item.product_name}`
                                                );

                                                window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
                                            }}
                                        >
                                            <i className="fab fa-whatsapp"></i>
                                        </button>
                                        <a className='product-image' onClick={() => navigate('/carddetails/' + item.id)}>
                                            <img src={item.product_images[0]} alt="product" />
                                        </a>
                                    </div>
                                    <div className="product-content">
                                        <h6 className="product-name">
                                            <a onClick={() => navigate('/carddetails/' + item.id)}>{item.product_name}</a>
                                        </h6>
                                        <h6 className="product-price">

                                            {item?.offer_price != 0 ? (
                                                <><del>₹{item?.mrp_price}</del>
                                                    <span>₹{item?.offer_price}<small>/piece</small></span></>
                                            ) : (
                                                <span>₹{item?.mrp_price}<small>/piece</small></span>
                                            )

                                            }
                                        </h6>
                                        <button className="product-add" title="Add to Cart" onClick={() => navigate('/carddetails/' + item.id)}>
                                            <a href='https://wa.me/919000000000'></a>
                                            <span>View All</span>
                                        </button>

                                    </div>
                                </div>
                            </div>
                        ))

                        }


                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-btn-25">
                                <a className='btn btn-outline' onClick={() => navigate("/cards")}>
                                    <i className="fas fa-eye"></i>
                                    <span>show more</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <section className="section newitem-part">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="section-heading">
                                <h2>Premium Invitations</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <Swiper
                                modules={[Autoplay, Navigation]}
                                spaceBetween={10}
                                slidesPerView={1}
                                loop={true}
                                watchSlidesProgress={true}
                                breakpoints={{
                                    480: { slidesPerView: 1 },
                                    768: { slidesPerView: 2 },
                                    1024: { slidesPerView: 4 },
                                    1280: { slidesPerView: 5 },
                                }}
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                }}


                            >
                                {plist.map((product, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="product-card-wrapper">
                                            <div className="product-card">
                                                <div className="product-media">
                                                    <div className="product-label">
                                                        <label className="label-text new">
                                                            {product?.product_category?.category_name}
                                                        </label>
                                                    </div>

                                                    <button
                                                        className="product-wish wish active"
                                                        onClick={() => {
                                                            const phone = "919865230900";
                                                            const message = encodeURIComponent(
                                                                `Hi, I’d like to know more about this product: ${product.product_name}`
                                                            );

                                                            window.open(
                                                                `https://wa.me/${phone}?text=${message}`,
                                                                "_blank"
                                                            );
                                                        }}
                                                    >
                                                        <i className="fab fa-whatsapp"></i>
                                                    </button>

                                                    <a
                                                        className="product-image"
                                                        onClick={() => navigate("/carddetails/" + product.id)}
                                                    >
                                                        <img src={product.product_images[0]} alt="product" />
                                                    </a>
                                                </div>

                                                <div className="product-content">
                                                    <h6 className="product-name">
                                                        <a onClick={() => navigate("/carddetails/" + product.id)}>
                                                            {product.product_name}
                                                        </a>
                                                    </h6>

                                                    <h6 className="product-price">
                                                        {product?.offer_price != 0 ? (
                                                            <>
                                                                <del>₹{product?.mrp_price}</del>
                                                                <span>
                                                                    ₹{product?.offer_price}
                                                                    <small>/piece</small>
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <span>
                                                                ₹{product?.mrp_price}
                                                                <small>/piece</small>
                                                            </span>
                                                        )}
                                                    </h6>

                                                    <button className="product-add" title="Add to Cart" onClick={() => navigate("/carddetails/" + product.id)}>
                                                        <span>View All</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            {/* <Slider {...premiumsettings} className="new-slider slider-arrow">
                                {plist.map((product, index) => (
                                    <div key={index} className="product-card-wrapper">
                                        <div className="product-card">
                                            <div className="product-media">
                                                <div className="product-label">
                                                    <label className="label-text new">{product?.product_category.category_name}</label>
                                                </div>
                                               
                                                <button
                                                    className="product-wish wish active"
                                                    onClick={() => {
                                                        const phone = "919865230900"; // include country code (91 for India)
                                                        const message = encodeURIComponent(
                                                            `Hi, I’d like to know more about this product: ${product.product_name}`
                                                        );

                                                        window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
                                                    }}
                                                >
                                                    <i className="fab fa-whatsapp"></i>
                                                </button>
                                                <a className='product-image' onClick={() => navigate('/carddetails/' + product.id)}>
                                                    <img src={product.product_images[0]} alt="product" />
                                                </a>
                                            </div>
                                            <div className="product-content">
                                                <h6 className="product-name">
                                                    <a onClick={() => navigate('/carddetails/' + product.id)}>{product.product_name}</a>
                                                </h6>
                                                <h6 className="product-price">
                                                    {product?.offer_price != 0 ? (
                                                        <><del>₹{product?.mrp_price}</del>
                                                            <span>₹{product?.offer_price}<small>/piece</small></span></>
                                                    ) : (
                                                        <span>₹{product?.mrp_price}<small>/piece</small></span>
                                                    )

                                                    }
                                                </h6>
                                                <button className="product-add" title="Add to Cart">
                                                    <span>View All</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider> */}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <div className="section-btn-25">
                                <a className='btn btn-outline' onClick={() => navigate("/cards")}>
                                    <i className="fas fa-eye"></i>
                                    <span>show more</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <div className="section promo-part">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-4 col-lg-4 px-xl-3">
                            <div className="promo-img">
                                <a onClick={() => navigate('/cards')}><img src={require("../assets/images/slider/asm-poster-pub.jpg")} alt="promo" /></a>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 col-lg-4 px-xl-3">
                            <div className="promo-img">
                                <a onClick={() => navigate('/cards')}><img src={require("../assets/images/slider/asm-poster-house.jpg")} alt="promo" /></a>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 col-lg-4 px-xl-3">
                            <div className="promo-img">
                                <a onClick={() => navigate('/cards')}><img src={require("../assets/images/slider/asm-poster-ear.jpeg")} alt="promo" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section testimonial-part">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-heading">
                                <h2>client's feedback</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <Slider {...testimonialSettings} className="testimonial-slider slider-arrow">
                                {reviews.map((item, index) => (
                                    <div key={index} className="testimonial-card-wrapper">
                                        <div className="testimonial-card">
                                            <i className="fas fa-quote-left"></i>
                                            <p>{item.text}</p>
                                            <h5>{item.name}</h5>
                                            <ul>
                                                {[...Array(5)].map((_, i) => (
                                                    <li key={i} className="fas fa-star"></li>
                                                ))}
                                            </ul>
                                            <img src={item.img} alt="testimonial user" />
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section testimonial-part-mobile">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-heading">
                                <h2>client's feedback</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <Slider {...responsiveTestimonialSettings} className="testimonial-slider slider-arrow">
                                {reviews.map((item, index) => (
                                    <div key={index} className="testimonial-card-wrapper">
                                        <div className="testimonial-card-mobile">
                                            <i className="fas fa-quote-left"></i>
                                            <p>{item.text}</p>
                                            <h5>{item.name}</h5>
                                            <ul>
                                                {[...Array(5)].map((_, i) => (
                                                    <li key={i} className="fas fa-star"></li>
                                                ))}
                                            </ul>
                                            <img src={item.img} alt="testimonial user" />
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
            <div className="section promo-part">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="promo-img">
                                <a onClick={() => navigate('/weddingwebsite')}><img src={require("../assets/images/slider/wedding-website-banner.jpg")} alt="promo" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

        </>
    )
}
